import { ContactInfoMode } from '../../utils/contact-info.validator';

export interface RegisterModeLabels {
    fieldLabel: string;
    buttonText: string;
    successContactType: string;
    errorBannerTitle: string;
    /** HTML input type for the contact field (drives mobile keyboard + selectors). */
    inputType: 'email' | 'tel' | 'text';
    /** HTML autocomplete token for the contact field. */
    autoComplete: string;
}

export const registerLabelsByMode: Record<ContactInfoMode, RegisterModeLabels> = {
    'email-only': {
        fieldLabel: 'Email',
        buttonText: 'Sign up with Email',
        successContactType: 'email address',
        errorBannerTitle: 'Something went wrong. Please try again.',
        inputType: 'email',
        autoComplete: 'email',
    },
    'phone-only': {
        fieldLabel: 'Phone',
        buttonText: 'Sign up with Phone',
        successContactType: 'phone number',
        errorBannerTitle: 'Something went wrong. Please try again.',
        inputType: 'tel',
        autoComplete: 'tel',
    },
    'either': {
        fieldLabel: 'Email or phone',
        buttonText: 'Sign up',
        successContactType: 'contact information',
        errorBannerTitle: 'Something went wrong. Please try again.',
        inputType: 'text',
        autoComplete: 'on',
    },
};
